(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dy_categories"] && !Shopify.designMode) return;
  try {
    
(function () {
  var lastShown = {};

  function init(root) {
    if (!root || root.dataset.dcReady) return;
    root.dataset.dcReady = "1";
    var sid = root.dataset.sectionId;
    var mq = window.matchMedia("(max-width: 1024px)");
    var canHover = window.matchMedia("(hover: hover) and (pointer: fine)");
    var depts = Array.prototype.slice.call(root.querySelectorAll(".dc-dept"));

    function sync() {
      depts.forEach(function (d) {
        var on = mq.matches ? d.classList.contains("is-open") : d.classList.contains("is-current");
        d.querySelector(".dc-dept__toggle").setAttribute("aria-expanded", on ? "true" : "false");
      });
    }
    function fit(d) {
      var panel = d.querySelector(".dc-panel");
      var reading = panel.querySelector(".dc-shelf.is-active .dc-reading");
      if (mq.matches || !reading) { panel.style.minHeight = ""; return; }
      panel.style.minHeight = (reading.offsetTop + reading.offsetHeight + 40) + "px";
    }
    function fitCurrent() {
      depts.forEach(function (d) { if (d.classList.contains("is-current")) fit(d); });
    }
    function setCurrent(d) {
      depts.forEach(function (x) { x.classList.toggle("is-current", x === d); });
      sync();
      fit(d);
    }
    function setShelf(d, s) {
      Array.prototype.forEach.call(d.querySelectorAll(".dc-shelf"), function (x) {
        x.classList.toggle("is-active", x === s);
      });
      fit(d);
    }

    depts.forEach(function (d) {
      var toggle = d.querySelector(".dc-dept__toggle");
      toggle.addEventListener("click", function () {
        if (mq.matches) { d.classList.toggle("is-open"); sync(); }
        else setCurrent(d);
      });
      toggle.addEventListener("mouseenter", function () {
        if (!mq.matches && canHover.matches) setCurrent(d);
      });
      Array.prototype.forEach.call(d.querySelectorAll(".dc-shelf"), function (s) {
        function act() { if (!mq.matches) setShelf(d, s); }
        s.addEventListener("mouseenter", act);
        s.querySelector(".dc-shelf__link").addEventListener("focus", act);
      });
    });

    root._dcShow = function (el) {
      var d = el.closest(".dc-dept");
      if (!d) return;
      d.classList.add("is-open");
      setCurrent(d);
      var s = el.closest(".dc-shelf");
      if (s) setShelf(d, s);
      var b = el.closest("[data-dc-block]");
      if (b && sid) lastShown[sid] = b.getAttribute("data-dc-block");
    };

    // Theme editor: stay on the block being edited after each preview refresh
    var keep = sid && lastShown[sid] && root.querySelector('[data-dc-block="' + lastShown[sid] + '"]');
    if (keep) root._dcShow(keep);

    var hash = decodeURIComponent(window.location.hash.slice(1));
    var target = hash && document.getElementById(hash);
    if (!keep && target && root.contains(target) && target.classList.contains("dc-panel")) {
      root._dcShow(target);
    }

    function refresh() { sync(); fitCurrent(); }
    if (mq.addEventListener) mq.addEventListener("change", refresh); else mq.addListener(refresh);
    var t;
    window.addEventListener("resize", function () { clearTimeout(t); t = setTimeout(fitCurrent, 150); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitCurrent);
    refresh();
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll(".dc-menu"), init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();

  document.addEventListener("shopify:section:load", function (e) {
    init(e.target.querySelector(".dc-menu"));
  });
  document.addEventListener("shopify:block:select", function (e) {
    var root = e.target.closest && e.target.closest(".dc-menu");
    if (root && root._dcShow) root._dcShow(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
(function () {
  function play(stage) {
    if (!stage || stage.classList.contains("is-playing")) return;
    var src = stage.getAttribute("data-embed");
    if (!src) return;
    var f = document.createElement("iframe");
    f.src = src;
    f.title = stage.getAttribute("data-title") || "Video";
    f.allow = "autoplay; encrypted-media; picture-in-picture; fullscreen";
    f.allowFullscreen = true;
    stage.appendChild(f);
    stage.classList.add("is-playing");
    f.focus();
  }

  document.addEventListener("click", function (e) {
    var t = e.target.closest && e.target.closest("[data-vs-play]");
    if (t) play(t.closest(".vs__stage"));
  });

  // Respect shoppers who turn off motion: stop the looping MP4 and give them controls
  function calm() {
    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    Array.prototype.forEach.call(document.querySelectorAll(".vs__stage--mp4 video"), function (v) {
      v.pause();
      v.controls = true;
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", calm);
  else calm();
  document.addEventListener("shopify:section:load", calm);
})();

  } catch(e) { console.error(e); }
})();
})();
